import { MediumCacheModel } from './MediumCache';
import {
  EmploymentType,
  HoursPerWeek,
  ProfessionExperienceLevel,
  RemoteWork,
  SalaryAmountType,
  Shift,
  VacancyCandidates,
  VacancyLayoutVersion,
  VacancyStatus,
} from './VacancyEnums';
import { VacancyProfessionModel } from './VacancyProfessionsInfo';
import { VacancyEducationLevelModel, VacancySkillModel } from './VacancySkill';

export interface DigitalVacancyModel {
  id: string;
  work_experience_level: ProfessionExperienceLevel;
  photo_id: string | null;
  photo: MediumCacheModel | null;
  job_title: string | null;
  job_description: string | null;
  organization: string | null;
  orgranization_url: string | null;
  activated: string | null;
  status: VacancyStatus;
  hours_range: HoursPerWeek;
  shifts: Shift[] | null;
  number_of_candidates: VacancyCandidates;
  employment_type: EmploymentType;
  salary_type: SalaryAmountType;
  remote_work: RemoteWork;
  salary_per_hour: number | null;
  salary_range_min: number | null;
  salary_range_max: number | null;
  salary_currency: string | null;
  location: string | null;
  is_favorite: boolean;
  match_score: number | null;
  recruiter_id: string | null;
  recruiter: string | null;
  layout_version: VacancyLayoutVersion;
  professions: VacancyProfessionModel[] | null;
  education_levels: VacancyEducationLevelModel[] | null;
  skills: VacancySkillModel[] | null;
  soft_skills: VacancySkillModel[] | null;
  knowledge_skills: VacancySkillModel[] | null;
  language_skills: VacancySkillModel[] | null;
  matching_skills: VacancySkillModel[] | null;
  benefits: string[] | null;
  tags: string[] | null;
}

export interface DigitalVacancyListItemModel {
  id: string;
  company_id: string | null;
  job_title: string | null;
  work_experience_level: ProfessionExperienceLevel;
  matches: number;
  status: VacancyStatus;
  activated: string | null;
  hours_range: HoursPerWeek;
  shifts: Shift[] | null;
  number_of_candidates: VacancyCandidates;
  employment_type: EmploymentType;
  remote_work: RemoteWork;
  location: string | null;
}

export enum SearchMode {
  ByWorkExperience = 1,
  ByDreamProfessions = 2,
  SurpriseMe = 3,
}
